import React, { ReactNode } from 'react'
import CompanyLogo from '../../assets/afbc.png'
import ReInvestStepper from 'components/ReInvestStepper'

interface ReinvestWrapperProps {
  sideImage: string
  title: string
  currentStage: number
  children: ReactNode
}

const ReinvestWrapper: React.FC<ReinvestWrapperProps> = ({ sideImage, title, children, currentStage }) => {
  return (
    <div className="flex h-screen w-full flex-col md:flex-row md:justify-start">
      <div className="mt-10 flex flex-col sm:w-screen md:mt-0 md:min-h-screen md:w-[45%] lg:w-[40%] xl:w-[35%]">
        <div className="relative w-screen px-10 sm:h-auto sm:px-16 md:hidden">
          <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
        </div>
        <div className="relative hidden flex-grow md:flex">
          <img className="flex h-screen w-full" src={sideImage} alt="SideImage" />
        </div>
      </div>

      <div className="flex flex-col p-10 sm:w-[100%] md:w-[55%] lg:h-screen lg:w-[60%] lg:overflow-y-scroll xl:w-[65%]">
        <div className="md:my-3">
          <ReInvestStepper current={currentStage} />
        </div>

        <div className="py-4 text-left text-2xl font-semibold text-gray-900 md:py-12 md:pb-10 md:text-4xl">{title}</div>

        {children}
      </div>
    </div>
  )
}

export default ReinvestWrapper
